import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import { useDebounce } from 'use-debounce';
import Input from '../../components/input';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Paginator } from '../../components/Paginator';
import { useSearchParams } from 'react-router-dom';
import { RxCross2 } from "react-icons/rx";

const statusString = (admin, user) => {
    let status = ""
    if ((user.length !== 0 && !user.includes('Hidden'))) {
        status = "Visible"
    }
    else {
        status = "Hidden"
    }
    return `${status}`
}

const EditBulkOrgSubscription = () => {
    const [loading, setLoading] = useState(false)
    const { accountType, allDocTemplate } = useSelector((state) => state.globalAuth);
    const axiosInstance = useAxiosInstance()
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [intermidiatePageNumber, setIntermidiatePageNumber] = useState(false)
    const [response, setResponse] = useState({})
    const [orgActiveStatus, setOrgActiveStatus] = useState('all')

    const [orgType, setOrgType] = useState('all')
    const [userSearch, setUserSearch] = useState("");
    const [userQuery] = useDebounce(userSearch, 1000);
    const [searchParam, setSearchParam] = useSearchParams()
    const [multiSelectOrgNames, setMultiSelectOrgNames] = useState([]);
    const [multiMarkUserLoading, setMultiMarkUserLoading] = useState(false);
    const [multiMarkAdminLoading, setMultiMarkAdminLoading] = useState(false);
    const [multiMarkBothHiddenLoading, setMultiMarkBothHiddenLoading] = useState(false);
    const [visibleStatus,setVisibleStatus] = useState('');
    const [pptx,setPPTX] = useState(null)
    const [pptLoading,setPPTLoading] = useState(false)
    const [docx,setDOCX] = useState(null)
    const [docxLoading,setDocxLoading] = useState(false)
    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get("/accounts/get_org_products/", {params:{
                page: page,
                page_size: pageSize,
                org_name: userQuery,
                report_type__pk: Number(searchParam.get('pk')),
                org_type: orgType,
                org_active_status: orgActiveStatus,
                visible_status:visibleStatus
            }})
            .then((res) => {
                setLoading(false);
                setResponse({ ...res.data });
                setIntermidiatePageNumber(res.data.current_page)
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [userQuery, orgType, orgActiveStatus, page, pageSize, visibleStatus]);

    useEffect(() => {
        setPage(1)
    }, [userQuery, orgType, orgActiveStatus, visibleStatus])

    const handleSubmit=(org_names, subs, report_type__pk,ppt=null,doc=null,scope,setLoading)=>{
        setLoading(true);
        console.log("report_type__pk",report_type__pk)
        const payload = {
            "org_names":org_names,
            "report_type__pk":report_type__pk,
            "scope":scope
        }
        if(subs){
            payload['subscriptions'] = subs
        }
        if (ppt){
            payload['pptx'] = ppt==="choose"?null:Number(ppt)
        }
        if (doc){
            payload['docx']  = doc==="choose"?null:Number(doc)
        }
        axiosInstance
            .post("/accounts/bulk_update_org_products/", payload)
            .then((res) => {
                setLoading(false);
                toast.success('Success full!')
            })
            .catch((err) => {
                setLoading(false);
                toast.success('failed!')
            });
    }
    return (
        <div className="h-screen overflow-y-auto pr-3 mr-1">
            <p className="text-base font-semibold  my-2 px-2 py-2 bg-white rounded-lg border">
                {searchParam.get('label')}
            </p>
            <div className='mt-3 grid grid-cols-4 gap-x-4'>
                <Input
                    type={"text"}
                    value={userSearch}
                    placeholder={'Search by org name'}
                    onChange={(e) => {
                        setUserSearch(e.target.value);
                    }}
                />

                <select
                    value={orgType}
                    onChange={(e) => {
                        setOrgType(e.target.value);
                    }}
                    className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                    placeholder="Enter your password"
                >
                    <option value={"all"}>all</option>
                    {accountType.map(item => <option key={item.label} value={item.label}>{item.label}</option>)}
                </select>

                <select
                    value={orgActiveStatus}
                    onChange={(e) => {
                        setOrgActiveStatus(e.target.value);
                    }}
                    className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                    placeholder="Enter your password"
                >
                    <option value={"all"}>all orgs</option>  
                    <option value={"active"}>Active orgs</option>
                    <option value={"inactive"}>Inactive orgs</option>
                </select>

                <select
                    value={visibleStatus}
                    onChange={(e) => {
                        setVisibleStatus(e.target.value);
                    }}
                    className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                    placeholder="Enter your password"
                >
                    <option value={""}>Visible and Hidden Both</option>  
                    <option value={"default"}>Visible</option>
                    <option value={"Hidden"}>Hidden</option>
                </select>
            </div>
            
            <span className='text-sm mt-4 font-medium flex justify-end'>*Select all will select values present in this current table page, if all values has to be selected try changing page size</span>
            <div className='flex gap-2 flex-wrap mb-4'><p>Selected Orgs:</p> {multiSelectOrgNames.map(it=>{
                return <p key={it} className='text-sm px-2 py-1 rounded flex gap-x-2 items-center bg-black text-white font-semibold'>{it} <RxCross2 
                className='cursor-pointer'
                onClick={()=>{
                    setMultiSelectOrgNames(prev=>prev.filter(prev_it=>prev_it!==it))
                }}
                fontWeight={500}/></p>}
            )}</div>       
                    
            <div className='flex justify-end mt-5 gap-x-2'>
                <button
                className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                onClick={()=>{
                    setMultiSelectOrgNames(response?.data?.map(it=>it.org_name))
                }}    
                >Select all</button>
                <button
                className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                    onClick={()=>{
                        setMultiSelectOrgNames([])
                    }}
                >Unselect all</button>
                <div>
                    <p className='text-sm font-semibold'>Select PPTX</p>
                    <select
                        value={pptx}
                        onChange={e=>{
                            setPPTX(Number(e.target.value))
                            handleSubmit(
                                multiSelectOrgNames,
                                null,
                                Number(searchParam.get('pk')),
                                e.target.value,
                                null,
                                ['ppt'],
                                setPPTLoading
                            )
                        }}
                        disabled={pptLoading}
                        className="border disabled:bg-gray-50  disabled:cursor-not-allowed rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                        placeholder="Enter your password"
                    >
                        <option value={'choose'}>choose</option>
                        {allDocTemplate?.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                    </select>
                </div>

                <div>
                    <p className='text-sm font-semibold'>Select DOCX</p>
                    <select
                        value={docx}
                        onChange={e=>{
                            setDOCX(Number(e.target.value))

                            handleSubmit(
                                multiSelectOrgNames,
                                null,
                                Number(searchParam.get('pk')),
                                null,
                                e.target.value,
                                ['doc'],
                                setDocxLoading
                            )
                        }}
                        disabled={docxLoading}
                        className="border disabled:bg-gray-50 disabled:cursor-not-allowed  rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                        placeholder="Enter your password"
                    >
                        <option value={'choose'}>choose</option>
                        {allDocTemplate?.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                    </select>
                </div>    

                <button
                    className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                    disabled={multiMarkUserLoading}
                    onClick={() => {
                        handleSubmit(
                            multiSelectOrgNames,
                            ['default'],
                            Number(searchParam.get('pk')),
                            null,
                            null,
                            ['user'],
                            setMultiMarkUserLoading
                        )
                    }}
                >Mark Selected as Visible</button>
                {/* <button
                    className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                    disabled={multiMarkAdminLoading}
                    onClick={() => {
                        handleSubmit(
                            multiSelectOrgNames,
                            ['default'],
                            Number(searchParam.get('pk')),
                            null,
                            null,
                            ['admin'],
                            setMultiMarkAdminLoading
                        )
                    }}
                >Mark Selected as Admin</button> */}
                <button
                    className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                    disabled={multiMarkBothHiddenLoading}
                    onClick={() => {
                        handleSubmit(
                            multiSelectOrgNames,
                            ['Hidden'],
                            Number(searchParam.get('pk')),
                            null,
                            null,
                            ['admin','user'],
                            setMultiMarkBothHiddenLoading
                        )
                    }}
                >Mark Selected as Hidden</button>

            </div>
            <div className='mt-2 h-[70vh] overflow-y-auto pr-1'>
                {loading ? <p>Loading...</p> :
                    <div>{response?.data?.map((orgProductDetails, idx) => {
                        return <OrgProductCard
                            orgProductDetails={orgProductDetails}
                            multiSelectOrgNames={multiSelectOrgNames}
                            setMultiSelectOrgNames={setMultiSelectOrgNames}
                            key={`${idx}-${orgProductDetails.org_name}`}
                            pk={Number(searchParam.get('pk'))}
                            givenPptx={orgProductDetails.ppt_template}
                            givenDocx={orgProductDetails.docx_template}
                        />
                    })}</div>
                }
            </div>

            <Paginator
                data={response}
                loading={loading}
                setPage={setPage}
                setIntermidiatePageNumber={setIntermidiatePageNumber}
                intermidiatePageNumber={intermidiatePageNumber}
                setPageSize={setPageSize}
                pageSize={pageSize}
            />
        </div>
    )
}

export default EditBulkOrgSubscription


const OrgProductCard = ({ orgProductDetails, setMultiSelectOrgNames, multiSelectOrgNames, pk, givenPptx=null, givenDocx=null }) => {
    const [markUserLoading, setIsMarkUserLoading] = useState(false);
    const [markAdminLoading, setIsMarkAdminLoading] = useState(false);
    const [markHiddenLoading, setMarkHiddenLoading] = useState(false);
    const [markVisibleLoading, setMarkVisibleLoading] = useState(false);
    const axiosInstance = useAxiosInstance()
    const { allDocTemplate } = useSelector((state) => state.globalAuth);
    
    const [pptx, setPptx] = useState(givenPptx)
    const [pptxLoading,setPPTXLoading] = useState(false);
    const [docx, setDocx] = useState(givenDocx)
    const [docxLoading,setDocxLoading] = useState(false);

    const submit_products = (orgName, productPk, subsArray=null, modification_type, setIsLoading, pptx=null, docx=null,scope=[]) => {
        setIsLoading(true);
        setMarkHiddenLoading(true)
        setMarkVisibleLoading(true)
        const payload ={
            org_name: orgName,
            report_type: productPk,
            modification_type: modification_type,
            scope:scope
        }
        if(subsArray){
            payload['subscription_status']=subsArray
        }
        console.log(scope, pptx)
        if (pptx){
            payload['pptx']=pptx==="choose"? null:pptx 
        }
        if(docx){
            payload['docx']=docx==="choose"? null:docx
        }
        axiosInstance
            .post("/accounts/update_org_product/", payload)
            .then(() => {
                toast.success(`${orgName} for report_label ${productPk} is done`);
                setMarkHiddenLoading(false)
                setMarkVisibleLoading(false)
                setIsLoading(false);
            })
            .catch((err) => {
                toast.error(`${orgName} for report_label ${productPk} is failed.`);
            });
    };


    return <div
        className='flex p-3 items-center rounded-xl mb-2 border bg-white w-full'
    >   
        <div className='flex w-[20%] gap-x-1 items-center'>
            <input
                type='checkbox'
                checked={multiSelectOrgNames.includes(orgProductDetails.org_name)}
                onClick={() => {
                    if (!multiSelectOrgNames.includes(orgProductDetails.org_name)) {
                        setMultiSelectOrgNames(prev => [...prev, orgProductDetails.org_name])
                    } else {
                        setMultiSelectOrgNames(prev => prev.filter(it => it !== orgProductDetails.org_name))
                    }
                }}
            />
            <p className='text-sm font-semibold'>{orgProductDetails.org_name}</p>
        </div>

        <div className='w-[15%]'>
            <p className='text-sm font-semibold'>
                {statusString([], orgProductDetails.user)}
            </p>
        </div>

        <div className='w-[65%] flex gap-x-1 justify-center'>
            <div>
                <p className='text-sm font-semibold'>Select PPTX</p>
                <select
                    value={pptx}
                    disabled={pptxLoading}
                    onChange={(e) => {
                        setPptx(e.target.value);
                        submit_products(
                            orgProductDetails.org_name,
                            pk,
                            null,
                            'user',
                            setPPTXLoading,
                            e.target.value,
                            docx,
                            ['ppt']
                        )
                    }}
                    className="border disabled:bg-gray-50  disabled:cursor-not-allowed rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                    placeholder="Enter your password"
                >
                    <option value={"choose"}>choose</option>
                    {allDocTemplate?.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                </select>
            </div>

            <div>
                <p className='text-sm font-semibold'>Select DOCX</p>
                <select
                    value={docx}
                    disabled={docxLoading}
                    onChange={(e) => {
                        setDocx(e.target.value);
                        submit_products(
                            orgProductDetails.org_name,
                            pk,
                            null,
                            'user',
                            setDocxLoading,
                            pptx,
                            e.target.value,
                            ['doc']
                        )
                    }}
                    className="border disabled:bg-gray-50 disabled:cursor-not-allowed  rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
                    placeholder="Enter your password"
                >
                    <option value={'choose'}>choose</option>
                    {allDocTemplate?.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                </select>
            </div>
            <button
                className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                disabled={markUserLoading}
                onClick={() => {
                    submit_products(
                        orgProductDetails.org_name,
                        pk,
                        ['default'],
                        'user',
                        setIsMarkUserLoading
                    )
                }}
            >Mark Visible</button>

            {/* <button
                className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                disabled={markAdminLoading}
                onClick={() => {
                    submit_products(
                        orgProductDetails.org_name,
                        pk,
                        ['default'],
                        'admin',
                        setIsMarkAdminLoading
                    )
                }}
            >Mark Admin</button> */}

            <button
                className='px-2 py-1  border text-white bg-black rounded-lg text-xs disabled:bg-white disabled:text-black disabled:cursor-not-allowed '
                disabled={markHiddenLoading}
                onClick={() => {
                    submit_products(
                        orgProductDetails.org_name,
                        pk,
                        ['Hidden'],
                        'user',
                        setIsMarkUserLoading
                    )
                    // submit_products(
                    //     orgProductDetails.org_name,
                    //     pk,
                    //     ['Hidden'],
                    //     'admin',
                    //     setIsMarkAdminLoading
                    // )
                }}
            >Mark hidden</button>
        </div>
    </div>
}